import { memo } from "react";

import { areEqual } from "react-window";

import { type MyLensesLens } from "../../../../gql-generated/types";
import { type LensModalProps } from "../../../../lenses/models";
import { LoadableItem } from "../../../../shared/components";
import { type VirtualizedListItemProps } from "../../../../shared/models";

import { LensRow } from "./LensRow";

export interface LoadableLensRowData {
    distributionRestrictionsProps: LensModalProps;
}

export const LoadableLensRow = memo<VirtualizedListItemProps<MyLensesLens, LoadableLensRowData>>(
    ({ index, style, data: { list, data } }) => {
        const lens = list[index];
        return (
            <LoadableItem style={style} data={lens} skeletonHeight={16}>
                {lens && data ? (
                    <LensRow
                        distributionRestrictionsProps={data.distributionRestrictionsProps}
                        style={style}
                        lens={lens}
                    />
                ) : (
                    <></>
                )}
            </LoadableItem>
        );
    },
    areEqual,
);
